import React from 'react';
import cn from 'classnames';
import {CircularProgress, Typography, withStyles} from '@material-ui/core';
import BaseComponent from './BaseComponent';

export const TEXT_RIGHT = 'textRight';
export const TEXT_BOTTOM = 'textBottom';

const Loading = ({className, classes, textPosition, ...rest}) => (
    <BaseComponent className={cn(className, classes.loading, 'loading', textPosition)} {...rest}/>
);

export default withStyles({
    loading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& .progress': {
            marginRight: 5,
            color: '#7e7e7e',
        },
        '& .loadingText': {
            fontSize: 15,
            color: '#7e7e7e',
        },
        [`&.${TEXT_BOTTOM}`]: {
            flexDirection: 'column',
            '& .progress': {
                marginBottom: 5
            }
        },
        [`&.${TEXT_RIGHT}`]: {
            flexDirection: 'row'
        },
    }
})(Loading);

export const Progress = ({className, ...rest}) => (
    <BaseComponent className={cn(className, 'progress')} {...rest}/>
);
Progress.defaultProps = {
    as: CircularProgress,
    size: 20,
};

export const LoadingText = ({className, ...rest}) => (
    <BaseComponent className={cn(className, 'loadingText')} {...rest}/>
);
LoadingText.defaultProps = {
    as: Typography,
    size: 20,
    variant: 'h6',
    color: 'primary',
};
